export const getTodayIndex = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();

    // sunday case
    if (dayOfWeek === 0) return 6;

    return dayOfWeek - 1;
};
